<template>
  <div>
    <div>
      <strong>
        <div>
            Random episode from season:
        </div>
        <span>
          <a href="javascript:;" v-on:click="getAnyRandomEpisode">Any</a>
        </span>
        <span v-for="season in epData" :key="season.title" >
          &nbsp;
          <a href="javascript:;" v-on:click="getSeasonRandomEpisode(season.airedSeason)">
            {{ season.airedSeason }}
          </a>
        </span>
      </strong>
    </div>

    <div>
      <strong>
        <div>
            Browse episodes from season:
        </div>
        <span v-for="season in epData" :key="season.title" >
          &nbsp;
          <router-link :to="{ path: '/Browse/Season/' + season.airedSeason }">
            {{ season.airedSeason }}
          </router-link>
        </span>
      </strong>
    </div>

    <div>
      <strong>
        <router-link to="/DrinkingRules">Drinking Rules</router-link>
      </strong>
    </div>
  </div>
</template>

<script>
import getRandomEpisode from '../lib/getRandomEpisode';

export default {
  name: 'intro',
  data() {
    return {
      epData: this.$store.getters.epData
    };
  },
  methods: {
    getRandomEpisode,
    getAnyRandomEpisode() {
      this.within = 'all';
      this.seasonNumber = 'all';
      this.getRandomEpisode();
    },
    getSeasonRandomEpisode(seasonNumber) {
      this.within = 'season';
      this.seasonNumber = seasonNumber;
      this.getRandomEpisode();
    }
  }
};
</script>



// WEBPACK FOOTER //
// Intro.vue?129fcc1e